<template>
  <div class="container-fluid py-4">
    <div class="row">
      <div class="col-12">
        <div class="card my-4">
          <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
            <div class="bg-gradient-success shadow-success border-radius-lg pt-4 pb-3">
              <div class="d-flex justify-content-between align-items-center flex-wrap px-3">
                <h6 class="text-white text-capitalize">출석현황 엑셀 다운로드</h6>
              </div>
            </div>
          </div>
          <div class="card-body px-4 pb-4">
            <div class="row">
              <div class="col-md-4 mb-3">
                <label class="form-label">부서 선택</label>
                <select 
                  v-model="filters.department" 
                  class="form-select" 
                  required
                  style="border: 1px solid #ced4da; padding-left: 10px;"
                >
                  <option value="">부서 선택 *</option>
                  <option 
                    v-for="department in departments" 
                    :key="department.id" 
                    :value="department.id"
                  >
                    &nbsp;{{ department.name }}
                  </option>
                </select>
              </div>
              <div class="col-md-8 mb-3">
                <label class="form-label">날짜 범위</label>
                <div class="d-flex">
                  <input 
                    type="date" 
                    v-model="filters.startDate" 
                    class="form-control me-2" 
                    required
                    style="border: 1px solid #ced4da; padding-left: 10px;"
                  >
                  <input 
                    type="date" 
                    v-model="filters.endDate" 
                    class="form-control" 
                    required
                    style="border: 1px solid #ced4da; padding-left: 10px;"
                  >
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-10 text-right">
              </div>
              <div class="col-2 text-right">
                <button 
                  @click="downloadExcel" 
                  class="btn btn-success"
                  :disabled="!isFormValid"
                >
                  엑셀 다운로드
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import apiservice from '../services/apiservice';
import * as XLSX from 'xlsx';

export default {
  name: 'FileList',
  data() {
    const currentYear = new Date().getFullYear();
    const today = new Date().toISOString().split('T')[0];
    const firstDayOfYear = `${currentYear}-01-01`;

    return {
      filters: {
        department: '',
        startDate: firstDayOfYear,
        endDate: today
      },
      departments: [],
      isSuperUser: this.$store.state.userData?.superuser === '1'
    };
  },
  computed: {
    isFormValid() {
      return this.filters.department && 
             this.filters.startDate && 
             this.filters.endDate;
    }
  },
  methods: {
    async fetchDepartments() {
      try {
        const response = await apiservice.getdeptlist();
        this.departments = response.data.data.map(department => ({
          id: department.code,
          name: department.codename
        }));

        // superuser가 아닌 경우 classid로 department 고정
        const userData = this.$store.state.userData;
        if (userData && userData.superuser !== '1') {
          this.filters.department = userData.classid;
          
          // 비슈퍼유저의 경우 해당 부서만 필터링
          this.departments = this.departments.filter(
            department => department.id === userData.classid
          );
        }
      } catch (error) {
        console.error("Failed to fetch department list:", error);
      }
    },
    async downloadExcel() {
      // 필수 입력값 검증
      if (!this.isFormValid) {
        alert('부서와 날짜 범위를 모두 선택해주세요.');
        return;
      }

      try {
        // 출석 데이터 가져오기
        const response = await axios.post('/api/filelist.php', {
          department: this.filters.department,
          startDate: this.filters.startDate,
          endDate: this.filters.endDate
        });

        // 데이터 변환
        const data = response.data.map(record => ({
          '학년': record.grade,
          '반': record.gradename,
          '날짜': record.attenddate,
          '이름': record.name,
          '출석': record.attendyn,
          '생년월일': record.birthday,
          '출석체크시간': record.createdt
        }));

        // 워크시트 생성
        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, '출석현황');

        // 엑셀 파일 생성 및 다운로드
        const filename = `출석현황_${this.filters.startDate}_${this.filters.endDate}.xlsx`;
        XLSX.writeFile(workbook, filename);

      } catch (error) {
        console.error("엑셀 다운로드 중 오류 발생:", error);
        alert('엑셀 다운로드 중 오류가 발생했습니다.');
      }
    }
  },
  mounted() {
    this.fetchDepartments();
  }
};
</script>

<style scoped>
.form-label {
  margin-bottom: 0.5rem;
  font-weight: bold;
}
.btn-success {
  background-color: #4CAF50;
  border-color: #4CAF50;
}
.btn-success:hover {
  background-color: #45a049;
}
</style>